import { useTranslation } from "react-i18next";

import { Text } from "#shared/view/components/Text";

export const WaitingForDataState = () => {
  const { t } = useTranslation();

  return (
    <Text fz={"xs"} c={"dimmed"}>
      {t("qrl.price.noSourceData")}
    </Text>
  );
};
